import { QueryClient } from "react-query";
import { storage } from "../utils/helper";

const queryErrorHandler = (err) => {
	if (storage.getToken()) {
		// storage.clearToken();
		alert("Error");
		// setTimeout(() => {
		// 	window.location.reload();
		// }, 10);
	}
};

const defaultQueryClientOptions = {
	queries: {
		onError: queryErrorHandler,
		retry: 2,
		staleTime: 600000, // 10 minutes
		cacheTime: 900000, // default cacheTime is 5 minutes; doesn't make sense for staleTime to exceed cacheTime
		// refetchOnMount: true,
		// refetchOnWindowFocus: true,
		// refetchOnReconnect: true,
	},
	mutations: {
		onError: queryErrorHandler,
	},
};

export const queryClient = new QueryClient({
	defaultOptions: defaultQueryClientOptions,
});
